import { pushRoute } from '../../../lib/router.js';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import { getMultipleEditorsData } from '../../../components/editor/defaultOptions.js';
import { getOrgSlug, mapFinalFormErrors } from '../../../lib/utils.js';
import StepDetailsForm from '../../../components/portfolio/EditPortfolioForms/StepDetailsForm.jsx';
import useFormInitialValues from '../../../hooks/useFormInitialValues.js';
import {
  deletePortfolio,
  finishUpdatePortfolioDraft,
  selectPortfolioDraft,
  selectPortfolioDraftId,
  updatePortfolioDraft,
} from '../../../modules/portfolio.js';
import {
  navigateToStepGeneral,
  navigateToStepMilestones,
  onCreateUpdateCancel,
  onReset,
} from './utils/index.js';
import PortfolioHeader from '../../../components/headers/PageHeaders/Portfolio/PortfolioHeader.jsx';
import MultistepCombinedHeader from '../../../components/headers/FormHeaders/MultistepCombinedHeader.jsx';

const mapErrors = mapFinalFormErrors('Failed to save portfolio');

const mapStateToProps = (state, ownProps) => ({
  editing: !!ownProps.portfolioId,
  portfolioId: ownProps.portfolioId,
  draftId: selectPortfolioDraftId(state),
  portfolioDraft: selectPortfolioDraft(selectPortfolioDraftId(state))(state),
});

const mapDispatchToProps = {
  updatePortfolioDraft,
  finishUpdatePortfolioDraft,
  deletePortfolio,
};

function StepDetailsFormContainer({
  editing,
  draftId,
  portfolioId,
  portfolioDraft,
  deletePortfolio,
  updatePortfolioDraft,
  finishUpdatePortfolioDraft,
}) {
  const [fields, setFields] = useState(null);

  const goNext = () =>
    navigateToStepMilestones(editing, portfolioId, getOrgSlug());
  const goBack = () =>
    navigateToStepGeneral(editing, portfolioId, getOrgSlug());
  const onCancel = () =>
    onCreateUpdateCancel(draftId, deletePortfolio, getOrgSlug());

  const generateFields = () => {
    const filteredFields = portfolioDraft.custom_fields
      .filter((field) => field.allow_editor)
      .sort((a, b) => Number(a.priority) - Number(b.priority));
    const fields = filteredFields.map((item) => ({
      label: item.name,
      key: item.key,
      isEditor: item.editor,
      editorInstance: null,
    }));
    setFields(fields);
  };
  const initialValues = useFormInitialValues(
    draftId ? portfolioDraft : null,
    []
  );

  const updateEditorInstance = (editorObject, index) => {
    setFields((prevFields) => {
      const updatedObj = { ...prevFields[index], editorInstance: editorObject };
      return [
        ...prevFields.slice(0, index),
        updatedObj,
        ...prevFields.slice(index + 1),
      ];
    });
  };

  const onSubmit = (values) => {
    const { finish } = values;

    const editorInstances = fields.filter((field) => field.editorInstance);
    const composedData = (editorData) => {
      const editorFields = editorInstances.reduce((acc, item, index) => {
        acc[item.key] = JSON.stringify(editorData[index]);
        return acc;
      }, {});
      const nonEditorFields = fields
        .filter((field) => !field.isEditor)
        .reduce((acc, item) => {
          acc[item.key] = values[item.key] || null;
          return acc;
        }, {});

      return {
        ...editorFields,
        ...nonEditorFields,
      };
    };

    return getMultipleEditorsData(
      editorInstances.map((item) => item.editorInstance)
    ).then((editorData) =>
      (finish
        ? finishUpdatePortfolioDraft(draftId, composedData(editorData))
        : updatePortfolioDraft(draftId, composedData(editorData))
      )
        .then(({ result }) =>
          finish
            ? pushRoute('portfolio/show/info', { portfolioId: result })
            : goNext()
        )
        .catch(mapErrors)
    );
  };

  useEffect(() => {
    !portfolioDraft && onReset(editing, portfolioId, getOrgSlug());

    if (portfolioDraft && !fields) {
      generateFields();
    }
  }, []);

  return (
    <React.Fragment>
      <MultistepCombinedHeader
        editing={editing}
        subject={getOrgTermsContent('portfolio')}
        typeStep="Details"
      >
        <PortfolioHeader portfolio={portfolioDraft} editing={editing} />
      </MultistepCombinedHeader>
      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              {draftId ? (
                <Row>
                  <Col sm={10} smOffset={1}>
                    <Form
                      onSubmit={onSubmit}
                      onCancel={onCancel}
                      initialValues={initialValues}
                      updateEditorInstance={updateEditorInstance}
                      fields={fields || []}
                      onBack={goBack}
                      component={StepDetailsForm}
                    />
                  </Col>
                </Row>
              ) : null}
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepDetailsFormContainer);
